module.exports = __webpack_public_path__ + "img/app store logo_new.eae429b5.svg";